import React from 'react';
import classNames from "classnames";

export default function Loader({style, size, className, center}) {
    return (
        <div className={classNames(`Loader`, className, `Loader--${size}`, {
            'Loader--center': center
        })}
             style={style}
        />
    );
}
